import Vue from "vue";
import VueRouter from "vue-router";
import ChildSeat from "../ChildSeat.vue"; // 引入儿童座椅的组件
import ChildSeatC from "@/ChildSeatC.vue";
import AdultSeat from "../AdultSeat.vue"; // 引入成人座椅的绑定组件

// 引入成人座椅相关的h5页面
import wxcode from "../wxcode.vue"; // 引入微信扫码组件
import btnList from "@/btnList.vue"; // 选择充电、 功能套餐首页
import charge from "@/AdultSeat/charge.vue"; // 充电页面
import orderpay from "../orderpay.vue"; // 套餐价格
import my from "@/AdultSeat/my.vue"; // 我的页面

import orderList from "@/AdultSeat/orderList.vue"; // 全部订单、运行中订单、退款订单
import orderDetail from "@/AdultSeat/orderDetail.vue"; //订单详情

import shareImg from "@/postcardShare/shareImg.vue"; // 分享页面
import newPageIndex from "@/AdultNewPage/newPageIndex.vue"; // 成人新首页
import newPageMoneyList from "@/AdultNewPage/newPageMoneyList.vue"; // 套餐列表页
import newPageOrderList from "@/AdultNewPage/newPageOrderList.vue"; // 订单列表页
import newPageMy from "@/AdultNewPage/newPageMy.vue"; // 我的页
import newPageYinsi from "@/AdultNewPage/newPageYinsi.vue"; // 隐私
import newPageFuwu from "@/AdultNewPage/newPageFuwu.vue"; // 用户服务
import newPageHezuo from "@/AdultNewPage/newPageHezuo.vue"; // 商务合作
import newPageShouhou from "@/AdultNewPage/newPageShouhou.vue"; // 售后客服 



Vue.use(VueRouter);

const routes = [
  {
    path: "/shareimg",
    name: "shareimg",
    component: shareImg, // 分享页面
  },
  {
    path: "/ChildSeat",
    name: "ChildSeat",
    component: ChildSeat, // 儿童座椅的组件
  },
  {
    path: "/ChildSeatC",
    name: "ChildSeatC",
    component: ChildSeatC, // 私域
  },
  {
    path: "/AdultSeat",
    name: "AdultSeat",
    component: AdultSeat, // 成人座椅的绑定组件
  },
  {
    path: "/",
    redirect: "/orderpay", // 默认过渡页面
  },
  {
    path: "/orderpay",
    name: "wxcode",
    component: wxcode, // 过渡页面
  },
  {
    path: "/wxcode",
    name: "orderpay",
    component: orderpay, // 套餐价格
  },
  {
    path: "/btnList",
    name: "btnList",
    component: btnList, // 选择充电、 功能套餐
  },
  {
    path: "/charge",
    name: "charge",
    component: charge, // 充电页面
  },
  {
    path: "/my",
    name: "my",
    component: my, // 我的
  },

  {
    path: "/orderList",
    name: "orderList",
    component: orderList, // 订单列表
  },
  {
    path: "/orderDetail",
    name: "orderDetail",
    component: orderDetail, // 订单详情
  },
  {
    path: "/new-page-index",
    name: "newPageIndex",
    component: newPageIndex, // 成人新首页
  },
  {
    path: "/new-page-money-list",
    name: "newPageMoneyList",
    component: newPageMoneyList, // 套餐列表页
  },
  {
    path: "/new-page-order-list",
    name: "newPageOrderList",
    component: newPageOrderList, // 订单列表页
  },
  {
    path: "/new-page-yinsi",
    name: "newPageYinsi",
    component: newPageYinsi, // 隐私政策协议
  },
  {
    path: "/new-page-fuwu",
    name: "newPageFuwu",
    component: newPageFuwu, // 用户服务协议
  },
  {
    path: "/new-page-hezuo",
    name: "newPageHezuo",
    component: newPageHezuo, // 商务合作协议
  },
  {
    path: "/new-page-shouhou",
    name: "newPageShouhou",
    component: newPageShouhou, // 售后客服 
  },
  {
    path: "/new-page-my",
    name: "newPageMy",
    component: newPageMy, // 我的页
 }
];

const router = new VueRouter({
  mode: "history", // 可选：history模式（需服务器支持）
  base: process.env.BASE_URL,
  routes,
});

export default router;